import useDynamicConfig from './useDynamicConfig';
import useUserRole from './useUserRole';
import { CUSTOM_PROMPTS_ENABLED } from 'components/custom-prompts/featureFlag';

// Single place that decides who sees the "Custom prompt emails" feature (nav link, routes).
// Currently the same gate as the overview-history pages: SYSTEM_ROLES. The server is the
// real enforcement and only lets SYSTEM_ADMIN through (everyone else gets 403, which every
// page renders as <ForbiddenState />). To tighten the UI to SYSTEM_ADMIN only, change it here.
const useCustomPromptsAccess = () => {
  const { hasSystemRole } = useUserRole();
  const { SYSTEM_ROLES } = useDynamicConfig();

  return { enabled: CUSTOM_PROMPTS_ENABLED, hasAccess: CUSTOM_PROMPTS_ENABLED && hasSystemRole, allowedRoles: SYSTEM_ROLES };
};

export default useCustomPromptsAccess;
